import { Expose, Transform, Type} from 'class-transformer';
import { UUID } from './Uuid';
import { format, parseISO } from 'date-fns';

const currentDate = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

export class BasicData extends UUID {
    // @Expose()
    // createdAt: string = currentDate;

    // @Expose()
    // @Transform(({ value }) => (value ? format(parseISO(value), 'yyyy-MM-dd HH:mm:ss') : null))
    // updatedAt: string = currentDate;
}
export class BasicAuditedData extends BasicData {
 
    @Expose()
    @Type(() => Boolean)
    inactive: boolean;

} 